import { render, staticRenderFns } from "./ContProjectName.vue?vue&type=template&id=4041dc72&scoped=true&"
import script from "./ContProjectName.vue?vue&type=script&lang=js&"
export * from "./ContProjectName.vue?vue&type=script&lang=js&"
import style0 from "./ContProjectName.vue?vue&type=style&index=0&id=4041dc72&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4041dc72",
  null
  
)

export default component.exports